import React, { useContext, useEffect, useRef, useState } from "react";
import {
  ActivityIndicator,
  Image,
  SafeAreaView,
  ScrollView,
  Text,
  View,
  useWindowDimensions,
  TouchableOpacity,
  TouchableWithoutFeedback,
  Platform,
  StyleSheet,
} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import styled, { ThemeProvider, useTheme } from "styled-components/native";
import { useFonts } from "expo-font";

import { Bound, BoundMagic, DataContext, useMagic } from "opidcore";
import logo_gray from "../assets/grayscale_clean_logo_520.png";
import logo from "../assets/clean_logo_520.png";
import { OpidNavigatorThing, useOpidNavigator } from "./core/OpidNavigator";
import loading from "../assets/loading.gif";
import staticLogo from "../assets/icon.png";
import WasteBrand, { COLORS } from "../WasteTheme";
import {
  FlexBlock,
  BasicText,
  FlexBlockWrapped,
  Label,
  AppWrapper,
  AppShellStyle,
  Loading,
  Disclaimer,
} from "./Styles";
import { Icon, InputSelect, InputText } from "./index";
import _ from "lodash";

import withHover from "./core/withHover";
import moment from "moment";

import { MENU_ITEMS } from "./config/routes";
import { DatePicker, PeriodPicker } from "./core";
import Modal from "./core/Modal";
import Util from "./core/Util";
import { PortalDataContext } from "./PortalContext";
import { MagicalState } from "./core/MagicalState";

export default function WasteApp(props) {
  const [fontLoaded, fontError] = useFonts({
    "Red Hat Display": require("../assets/RedHatDisplay.ttf"),
  });

  const [portalData, setPortalData] = useState({});
  const [authToken, setAuthToken] = useState({ code: "loading" });
  const [theDates, setTheDates] = useState({ startDate: null, endDate: null });
  const [siteFilter, setSiteFilter] = useState(null);
  const [compareTo, setCompareTo] = useState("lastMonth");
  const [showFilters, setShowFilters] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dragLength = useRef(0);
  const [preflightComplete, setPreFlightComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [siteOptions, setSiteOptions] = useState([]);
  const storedSettings = useRef({
    siteOptions: undefined,
    startDate: undefined,
    endDate: undefined,
  });
  const appBodyRef = useRef(null);

  const startDate = theDates.startDate;
  const endDate = theDates.endDate;

  const portalRoot = "/dashboard";
  let defaultPath = portalRoot;
  if (!isMobile()) {
    if (
      window &&
      window.location &&
      window.location.pathname &&
      window.location.pathname.length > 2 &&
      window.location.pathname.indexOf("/auth") != 0
    ) {
      defaultPath = window.location.pathname;
    }
  }

  const [path, setPath] = useState(defaultPath);
  const pathToFetch = getHost() + "/api/v1/portal/";

  let controller = useRef();

  /* useEffect(()=>{
        if(storedSettings.current.siteOptions == undefined || siteFilter == null || storedSettings.current.startDate != theDates.startDate || storedSettings.current.endDate != theDates.endDate){
            storedSettings.current.siteOptions = portalData.umbrellaSites;
            storedSettings.current.startDate = theDates.startDate;
            storedSettings.current.endDate = theDates.endDate;

            let newOptions = [
                {label: "All Sites", value: null}
            ];

            const seen = {}

            _.forEach(storedSettings.current.siteOptions, (site)=>{
                if(seen[site.site_id] == undefined){
                    newOptions.push({label: site.name, value: site.site_id});
                    seen[site.site_id] = "seen";
                }
            });

            setSiteOptions(newOptions);
        }
    }, [portalData.umbrellaSites, theDates, siteFilter]); */

  useEffect(() => {
    let newOptions = [{ label: "All Sites", value: null }];

    const seen = {};

    _.forEach(portalData.umbrellaSites, (site) => {
      if (seen[site.site_id] == undefined) {
        newOptions.push({ label: site.name, value: site.site_id });
        seen[site.site_id] = "seen";
      }
    });

    setSiteOptions(newOptions);
  }, [portalData.umbrellaSites]);

  useEffect(() => {
    let tempPath = "";
    if (!isMobile()) {
      tempPath = window.location.pathname;
    } else {
      tempPath = path;
    }

    if (tempPath.startsWith("/auth")) {
      const authTokenCode = tempPath.split("/")[2];

      AsyncStorage.setItem("authTokenCode", authTokenCode);

      setAuthToken({ code: authTokenCode });
      setPath(defaultPath);

      //put the path back into the window location, opidnavigator does this everywhere else
      if (window && window.history && window.history.pushState) {
        window.history.pushState({}, null, defaultPath);
      }
    }
  }, [path]);

  useEffect(() => {
    if (
      authToken.code != null &&
      authToken.code != "loading" &&
      preflightComplete == false
    ) {
      const args = {
        auth_token: authToken.code,
        currentDate: moment().format("YYYY-MM"),
      };

      fetch(pathToFetch + "preloadDateRange", {
        body: JSON.stringify({ body: args }),
        mode: "cors",
        method: "POST",
        headers: { "Content-Type": "application/json", portalUI: "yes" }, //portalUI header used in backend api authentication
      })
        .then((r) => r.json())
        .then((r) => {
          if (r != undefined && r.length > 1) {
            setTheDates({
              startDate: moment(r[0]),
              endDate: moment(r[r.length - 1]),
            });
          }
          setPreFlightComplete(true);
        });
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken.code == "loading") {
      AsyncStorage.getItem("authTokenCode").then((code) => {
        if (code > "") {
          //setPath("/applogin");
          setAuthToken({ code: code });
          setShowFilters(true);
        } else {
          console.log("if you are reading this you don't have a token...");
          //alert('hey no token!');
          setPath("/applogin");
        }
      });

      /** 
            fetch(pathToFetch + 'auth',
            {credentials: "include"}).then( (r)=>r.json() ).then( (r)=>{
                if (r.result){
                    setAuthToken(r.result);
                }
            });
            **/
      return;
    }

    if (preflightComplete == true && startDate != null && endDate != null) {
      if (loading == true) {
        if (controller.current != null) {
          controller.current.abort();
          doFetch();
        }
      } else {
        setLoading(true);
      }
    }
  }, [compareTo, startDate, endDate, authToken, siteFilter, preflightComplete]);

  useEffect(() => {
    if (loading == true) {
      doFetch();
    }
  }, [loading]);

  const doFetch = () => {
    controller.current = new AbortController();
    const signal = controller.current.signal;

    const args = {
      auth_token: authToken.code,
      startDate: startDate.format("YYYY-MM"),
      endDate: endDate.format("YYYY-MM"),
      compareTo: compareTo,
      searchParams: { sites: [siteFilter] },
    };

    const opts = {
      body: JSON.stringify({ body: args }),
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json", portalUI: "yes" }, //portalUI header used in backend api authentication
      signal: signal,
    };

    fetch(pathToFetch + "myData", opts)
      .then((r) => {
        return r.json();
      })
      .then((r) => {
        r.authToken = authToken;
        r.siteFilter = siteFilter;
        controller.current = null;
        setPortalData(expandMetrics(r));
        setLoading(false);
      });
  };

  const _setCompareTo = (value) => {
    if (compareTo == value) {
      return;
    }

    if (value != null) {
      setCompareTo(value);
    }
  };

  const _setSiteFilter = (val) => {
    if (siteFilter == val) {
      return;
    }

    if (val == "" || val == "All Sites") {
      val = null;
    }
    setSiteFilter(val);
  };

  const windowSize = useWindowDimensions();

  if (isMobile() == true && fontLoaded == false) {
    return null;
  }

  if (startDate == null || endDate == null) {
    //return null;
  }

  let myBrand = { ...WasteBrand };
  myBrand.screen = windowSize.width > 768 ? "desktop" : "mobile";
  myBrand.icons = portalData.icons;

  const HoverImage = withHover((props) => {
    const hoverStuff = {};
    if (props.hovered) {
      hoverStuff.source = props.hoverSource;
    }
    return <Image {...props} {...hoverStuff} />;
  });

  const openMenu = (e) => {
    if (isMobile() == false) {
      dragLength.current = 0;
      return;
    }

    dragLength.current = e.nativeEvent.pageX - dragLength.current;

    if (dragLength.current > 100) {
      //swiping right more than 100px
      e.preventDefault();
      e.stopPropagation();
      dragLength.current = 0;

      setMenuOpen(true);
      return;
    }

    if (dragLength.current < -100) {
      //swiping left more than 100px
      e.preventDefault();
      e.stopPropagation();
      dragLength.current = 0;

      setMenuOpen(false);
      return;
    }

    dragLength.current = 0;
    return;
  };

  const setDate = (value, setter) => {
    if (theDates[setter] == value) {
      return;
    }

    const newDates = { ...theDates };
    let changed = false;

    if (value != null && value > "") {
      newDates[setter] = value;
      changed = true;
    }

    if (changed) {
      setTheDates(newDates);
    }
  };

  const scrollToInitialPosition = () => {
    if (appBodyRef.current != undefined) {
      setTimeout(() => {
        appBodyRef.current.scrollTo({ x: 0, y: 0, animated: false });
      }, 2000);
    }
  };

  return (
    <AppWrapper
      onTouchStart={(e) => {
        dragLength.current = e.nativeEvent.pageX;
      }}
      onTouchEnd={(e) => openMenu(e)}
    >
      <PortalDataContext.Provider value={portalData}>
        <ThemeProvider theme={myBrand}>
          <OpidNavigatorThing setter={setPath}>
            {!isMobile() ? <AppMenu setMenuOpen={setMenuOpen} /> : null}
            <AppShellStyle>
              <View style={{ zIndex: 9999 }}>
                <View style={{ elevation: 100 }}>
                  <TouchableOpacity
                    onPress={() =>
                      !isMobile() ? null : setMenuOpen(!menuOpen)
                    }
                  >
                    <HoverImage
                      source={logo_gray}
                      hoverSource={logo_gray}
                      style={{ width: 190, height: 100, marginLeft: 10 }}
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                  <Disclaimer>
                    Portal data is live and may vary throughout the month.
                    Please contact your account manager with any questions.
                  </Disclaimer>
                  <MobileMenu
                    menuOpen={menuOpen}
                    setMenuOpen={(val) => setMenuOpen(val)}
                  />
                </View>
                {showFilters && preflightComplete ? (
                  <Filters
                    portalData={portalData}
                    startDate={startDate}
                    endDate={endDate}
                    siteFilter={siteFilter}
                    compareTo={compareTo}
                    loading={loading}
                    siteOptions={siteOptions}
                  >
                    <MagicalState
                      to="startDate"
                      setter={(v) => setDate(v, "startDate")}
                    />
                    <MagicalState
                      to="endDate"
                      setter={(v) => setDate(v, "endDate")}
                    />
                    <MagicalState to="compareTo" setter={_setCompareTo} />
                    <MagicalState
                      to="siteFilter"
                      setter={(v) => _setSiteFilter(v)}
                    />
                  </Filters>
                ) : null}
              </View>
              <ScrollView
                ref={(ref) => (appBodyRef.current = ref)}
                onLayout={() => scrollToInitialPosition()}
              >
                <AppRouter
                  path={path}
                  portalData={portalData}
                  startDate={startDate}
                  endDate={endDate}
                  showFilters={showFilters}
                  setShowFilters={setShowFilters}
                />
              </ScrollView>
            </AppShellStyle>
          </OpidNavigatorThing>
        </ThemeProvider>
      </PortalDataContext.Provider>
    </AppWrapper>
  );
}

const MobileMenu = ({ menuOpen, setMenuOpen }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    if (modalVisible == false) {
      setModalContent(null);
    }
  }, [modalVisible]);

  useEffect(() => {
    if (menuOpen == true && modalVisible == false) {
      openModal();
    }
  }, [menuOpen]);

  const _setMenuOpen = (val) => {
    setMenuOpen(val);
    setModalVisible(val);
  };

  const openModal = () => {
    setModalContent(<AppMenu setMenuOpen={(val) => _setMenuOpen(val)} />);
    setModalVisible(true);
  };

  if (!isMobile()) {
    return null;
  }

  if (!menuOpen) {
    return null;
  }

  const styles = StyleSheet.create({
    extraModalStyles: {
      borderRadius: 0,
      alignSelf: "flex-start",
      height: "100%",
      marginLeft: 0,
    },
  });

  const MenuWrapper = styled.View`
    flex-direction: column;
    z-index: 100;
    elevation: 100;
  `;

  return (
    <MenuWrapper>
      <Modal
        modalVisible={modalVisible}
        setModalVisible={_setMenuOpen}
        customCloseText={null}
        extraModalStyles={styles.extraModalStyles}
      >
        {modalContent}
      </Modal>
    </MenuWrapper>
  );
};

const AppRouter = ({
  path,
  portalData,
  showFilters,
  setShowFilters,
  startDate,
  endDate,
}) => {
  const parameterProps = useRef({});
  let accessible = true;
  let menuItem = _.findLast(MENU_ITEMS, (i) => path.indexOf(i.path) == 0);

  useEffect(() => {
    let vals = [];
    if (menuItem && menuItem.parameters) {
      vals = _.replace(path, menuItem.path, "").split("/");
      parameterProps.current = _.fromPairs(
        vals.map((v, i) => [menuItem.parameters[i], v])
      );
    }

    if (vals.length > 0 || (menuItem && menuItem.hideFilters == true)) {
      if (showFilters == true) {
        setShowFilters(false);
      }
    } else {
      if (showFilters == false) {
        setShowFilters(true);
      }
    }
  }, [path]);

  if (menuItem == null) {
    return null;
  }

  if (portalData.user == undefined) {
    accessible = false;
  } else if (
    menuItem.access != undefined &&
    typeof menuItem.access === "function"
  ) {
    accessible = menuItem.access(portalData.user.portalProfileSettings) == true;
  } else if (menuItem.access != undefined) {
    accessible = menuItem.access == true;
  }

  //alert('heya ' + path + " " + accessible);

  if (!accessible && path != "/applogin") {
    return null;
  }

  const TheComponent = menuItem.component;
  return (
    <TheComponent
      portalData={portalData}
      startDate={startDate}
      endDate={endDate}
      {...parameterProps.current}
    />
  );
};

const AppHeader = styled(FlexBlockWrapped)`
  flex-direction: row;
  justify-content: space-between;
`;

const Filters = ({
  children,
  portalData,
  startDate,
  endDate,
  siteFilter,
  compareTo,
  loading = false,
  siteOptions,
}) => {
  const [disabledMonths, setDisabledMonths] = useState([]);
  const myBound = useMagic({
    startDate: startDate,
    endDate: endDate,
    siteFilter: siteFilter,
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  useEffect(() => {
    if (modalVisible == false) {
      setModalContent(null);
    }
  }, [modalVisible]);

  useEffect(() => {
    if (myBound.magicalGet("startDate") != startDate) {
      myBound.magicalSet("startDate", startDate);
    }
    if (myBound.magicalGet("endDate") != endDate) {
      myBound.magicalSet("endDate", endDate);
    }
    if (myBound.magicalGet("sitesOptions") != siteFilter) {
      myBound.magicalSet("sitesOptions", siteFilter);
    }
  }, [startDate, endDate, siteFilter]);

  const DesktopView = styled(FlexBlock)`
    justify-content: flex-end;
    align-items: center;
  `;

  const MobileView = styled(FlexBlock)`
    flex-direction: column;
    justify-content: center;
  `;

  let elementStyle = { alignItems: "center" };
  let FilterView = DesktopView;
  const showMobileView = isMobile();

  if (showMobileView) {
    FilterView = MobileView;

    elementStyle = {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      marginVertical: 10,
    };
  }

  const theView = (
    <Bound to={myBound} tagName={React.Fragment}>
      <FilterView>
        <InputSelect
          label="Showing:"
          field="siteFilter"
          defaultValue={"All Sites"}
          options={siteOptions}
          flexDirection="row"
          LabelType={Label}
          style={elementStyle}
        />
        <PeriodPicker
          label="Period From:"
          field1="startDate"
          flexDirection="row"
          LabelType={Label}
          disabledMonths={disabledMonths}
          style={elementStyle}
        />
        <PeriodPicker
          label="Period To:"
          field1="endDate"
          flexDirection="row"
          LabelType={Label}
          disabledMonths={disabledMonths}
          style={elementStyle}
        />
        {/**<InputSelect label="Compare To:" field="compareTo" defaultValue={compareTo} options={[{label: "Previous Year", value: "lastYear"}, {label: "Last Month", value: "lastMonth"}]} flexDirection="row" LabelType={Label}/>**/}
      </FilterView>
      {children}
    </Bound>
  );

  const openMobileFilters = () => {
    setModalContent(theView);
    setModalVisible(true);
  };

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "flex-end",
        alignItems: "center",
      }}
    >
      <Modal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        customCloseText="Search"
      >
        {modalContent}
      </Modal>
      <View style={{ paddingRight: 20 }}>
        <ActivityIndicator animating={loading} hidesWhenStopped={true} />
      </View>
      {showMobileView ? (
        <Icon icon="filter" onClick={() => openMobileFilters()} />
      ) : (
        theView
      )}
    </View>
  );
};

const MenuOuter = styled(FlexBlock)`
  flex-direction: column;
  flex-basis: auto;
`;

const mapMenuItem = (menuItem, setMenuOpen, navigation) => {
  let inner = null;

  if (menuItem.children != undefined) {
    inner = (
      <MenuOuter style={{ marginLeft: 38 }}>
        {_.map(menuItem.children, (c) =>
          mapMenuItem(c, setMenuOpen, navigation)
        )}
      </MenuOuter>
    );
  }

  return (
    <React.Fragment key={menuItem.key}>
      <MenuItem
        key={menuItem.key}
        navTo={(path) => {
          navigation.goto(path);
          setMenuOpen && setMenuOpen(false);
        }}
        {...menuItem}
      />
      {inner}
    </React.Fragment>
  );
};

const AppMenu = ({ setMenuOpen }) => {
  const portalDataContext = useContext(PortalDataContext);
  const navigation = useOpidNavigator();
  const theme = useTheme();

  const DesktopAppMenuOuter = styled.View`
    align-self: flex-start;
  `;

  const MobileAppMenuOuter = styled.View``;

  const doLogout = async () => {
    await AsyncStorage.removeItem("authTokenCode");

    if (!isMobile()) {
      window.location = "/portal/logout";
    } else {
      navigation.goto("/applogin");
      setMenuOpen(false);
    }
  };

  const AppMenuOuter = isMobile() ? MobileAppMenuOuter : DesktopAppMenuOuter;

  const menuItems = [];
  const tempHashedMenu = {};

  _.forEach(MENU_ITEMS, (menuItem) => {
    let inMenu = false;
    if (typeof menuItem.inMenu === "function") {
      if (portalDataContext.user == undefined) {
        inMenu = false;
      } else {
        inMenu =
          menuItem.inMenu(portalDataContext.user.portalProfileSettings) == true;
      }
    } else {
      inMenu = menuItem.inMenu == true;
    }

    if (inMenu) {
      tempHashedMenu[menuItem.key] = { ...menuItem };
    }
  });

  let toDrop = {};
  _.forEach(tempHashedMenu, (el, key) => {
    if (el.children != undefined) {
      tempHashedMenu[key].children = _.map(el.children, (cKey) => {
        toDrop[cKey] = "seen";
        return tempHashedMenu[cKey];
      });
    }
  });

  _.forEach(tempHashedMenu, (v, k) => {
    if (toDrop[k] == undefined) {
      menuItems.push(v);
    }
  });

  let icon = (
    <Image
      source={loading}
      style={{ flex: 1, flexBasis: "auto", width: 100, height: 100 }}
      resizeMode="contain"
    />
  );

  if (isMobile()) {
    icon = (
      <Image
        source={staticLogo}
        style={{ width: 100, height: 100 }}
        resizeMode="contain"
      />
    );
  }

  if (portalDataContext.user == undefined) {
    menuItems.splice(0);
  }

  return (
    <AppMenuOuter>
      {icon}
      <MenuOuter>
        {_.map(menuItems, (i) => mapMenuItem(i, setMenuOpen, navigation))}
        <MenuItem
          key="logout"
          path=""
          label="Logout"
          icon="sign-out"
          navTo={() => doLogout()}
        />
      </MenuOuter>
      <Text> </Text>
      <Text style={{ fontSize: 10, color: "#bbb" }}>v 2023.03.007</Text>
    </AppMenuOuter>
  );
};

const MenuItem = ({ path, icon, label, navTo }) => {
  const Wrapper = withHover(styled.View`
    background-color: ${(props) => (props.hovered ? COLORS.grey : "#fff0")};
    display: flex;
    flex-direction: row;
    padding: 15px;
  `);

  const MenuText = styled(BasicText)`
    font-size: 14px;
    color: #666;
    padding-left: 20px;
  `;

  const doNav = (path) => {
    if (path == undefined) {
      return;
    }

    navTo(path);
  };

  return (
    <TouchableOpacity onPress={() => doNav(path)}>
      <Wrapper>
        <Icon icon={icon} colour={COLORS.wsc_blue} size={18} />
        <MenuText>{label}</MenuText>
      </Wrapper>
    </TouchableOpacity>
  );
};

const expandMetrics = (portalData) => {
  const tempData = {};

  _.forEach(portalData.umbrellaSites, (site) => {
    if (tempData[site.site_id] == undefined) {
      tempData[site.site_id] = site;
      tempData[site.site_id].metric_tonnes_diverted = 0;
      tempData[site.site_id].metric_tonnes_waste = 0;
      tempData[site.site_id].total_costs = 0;
      tempData[site.site_id].total_savings = 0;
      tempData[site.site_id].baseline_total_costs = 0;
      tempData[site.site_id].cost_avoidance = 0;
      tempData[site.site_id].cost_avoidance_with_savings = 0;
    }
  });

  if (
    portalData.metrics != undefined &&
    portalData.metrics.diversion != undefined
  ) {
    _.forEach(portalData.metrics.diversion, (diversionMetric) => {
      if (tempData[diversionMetric.site] != undefined) {
        tempData[diversionMetric.site].metric_tonnes_diverted =
          diversionMetric.related.metricValue;
        tempData[diversionMetric.site].metric_tonnes_waste =
          diversionMetric.related.comparedValue;
      } else {
        console.log("something crazy happened and we shouldn't be here");
      }
    });
  }

  if (portalData.siteComparisonFinances != undefined) {
    _.forEach(portalData.siteComparisonFinances, (siteFinances) => {
      if (tempData[siteFinances.site_id] != undefined) {
        tempData[siteFinances.site_id].total_costs =
          (tempData[siteFinances.site_id].total_costs || 0) +
          siteFinances.total_costs;
        tempData[siteFinances.site_id].total_savings =
          (tempData[siteFinances.site_id].total_savings || 0) +
          siteFinances.total_savings;
        tempData[siteFinances.site_id].baseline_total_costs =
          (tempData[siteFinances.site_id].baseline_total_costs || 0) +
          siteFinances.baseline_total_costs;
        tempData[siteFinances.site_id].cost_avoidance =
          (tempData[siteFinances.site_id].cost_avoidance || 0) +
          siteFinances.cost_avoidance;
        tempData[siteFinances.site_id].cost_avoidance_with_savings =
          (tempData[siteFinances.site_id].cost_avoidance_with_savings || 0) +
          siteFinances.cost_avoidance_with_savings;
      } else {
        console.log("something crazy happened and we shouldn't be here");
      }
    });
  }

  const newData = _.map(_.values(tempData), (s) => {
    if (s.metric_tonnes_diverted == undefined) {
      s.metric_tonnes_diverted = 0;
    }
    if (s.metric_tonnes_waste == undefined) {
      s.metric_tonnes_waste = 0;
    }

    s.percent_diverted =
      (s.metric_tonnes_diverted /
        (s.metric_tonnes_diverted + s.metric_tonnes_waste)) *
      100;
    if (isNaN(s.percent_diverted)) {
      s.percent_diverted = 0;
    }

    s.ghg_reduction = s.epa_conversion_value * s.metric_tonnes_diverted;

    return s;
  });

  portalData.adjustedSiteData = newData;
  return portalData;
};

const isMobile = () => {
  return Util.isMobile();
};

const getHost = () => {
  return Util.getHost();
};

export { isMobile, getHost, PortalDataContext };
